import { Parameter } from "../../common/types/parameters";
import { SupplementalHeatingSource } from "../../common/types/values";
import { Condition } from "./types";
import { isMet } from "./util";

export const showWhenSupplementalDistrictHeatingCondition: Condition = {
  parameter: "SupplementalHeatingSource",
  value: SupplementalHeatingSource.DistrictHeating,
};

export const isDistrictHeatingSelectedAsSupplementalHeatingSource = (
  parameters: Parameter[]
) => isMet(showWhenSupplementalDistrictHeatingCondition, parameters);

export const getSupplementalId = (
  primaryHeatingTechnologyPrefix: string,
  supplementalHeatingTechnologyParameterId: string
) =>
  `${primaryHeatingTechnologyPrefix}Supplemental${supplementalHeatingTechnologyParameterId}`;
